import React, { Fragment, useEffect, forwardRef, useContext } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";
import { Grid, FormControl, MenuItem, Checkbox } from "@mui/material";
import { Button, InputLabel, Select, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import _ from "lodash";
import Loader from "../common/Loader";
import ProjectContext from "../../context/project/ProjectContext";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AddIntelliFiberClients(props: {
  showDialog: boolean;
  selectedUserRoles: any;
  userRoles: any;
  handleClose: Function;
  refresh: Function;
}) {
  const [open, setOpen] = React.useState(props.showDialog);

  let {
    loading,
    getClients,
    getAllRoles,
    getAllProjects,
    createUserRoles,
    createUserProjects,
    updateUserRoles,
    deleteUserProjects,
    getClientProjects,
    getUserProjects,
    getClientGroups,
  } = useContext(ProjectContext);

  const [rolesList, setRolesList] = React.useState<any>([]);
  const [clientsGroupList, setClientGroupList] = React.useState<any>([]);
  const [projectsList, setProjectsList] = React.useState<any>([]);

  const [newUser, setNewUser] = React.useState<any>({
    LoginID: "",
    RoleID: 1,
    GroupID: null,
  });
  const [selectedProjects, setSelectedProjects] = React.useState<any>([]);

  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState({ type: "", msg: "" });

  const handleClose = () => {
    console.log("close");
    props.handleClose();
    setOpen(false);
  };

  const disableUpdate = () => {
    console.log("disableUpdate ", props.selectedUserRoles, newUser);
    if (
      newUser.LoginID !== "" &&
      newUser.GroupID !== null
    ) {
      return _.isEqual(props.selectedUserRoles, newUser);
    } else {
      return true;
    }
  };

  const disableAdd = () => {
    console.log("disableAdd ", newUser);
    if (
      newUser.LoginID !== "" &&
      newUser.GroupID !== null
    ) {
      return false;
    } else {
      return true;
    }
  };

  const deleteProjects = async (projects) => {
    console.log("deleteProjects props", projects);

    if (deleteUserProjects) {
      try {
        let payload = {
          RoleID: 1,
          UserID: newUser.UserID,
          Projects: projects,
        };
        console.log("deleteProjects payload", payload);

        const res = await deleteUserProjects(payload);
        console.log("deleteProjects res", res);

        if (res) {
          return res;
        }
      } catch (error) {
        console.log("deleteProjects err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const deleteClientProjects = async (deleteClientIDs) => {
    console.log("deleteClientProjects props", deleteClientIDs);

    try {
      let getClients = deleteClientIDs.map((ele: any) => {
        return new Promise(async (resolve, reject) => {
          if (getClientProjects) {
            let res = await getClientProjects(ele);
            console.log("deleteClientProjects res", ele, res);
            if (res) {
              resolve(res);
            } else {
              reject(res);
            }
          } else {
            reject();
          }
        });
      });

      let getClientsRes = await Promise.all(getClients);
      console.log("deleteClientProjects getClientsRes", getClientsRes);

      if (getClientsRes) {
        let projectIds = getClientsRes
          .map((ele) => ele[0])
          .map((ele) => ele.ProjectID);
        console.log("deleteClientProjects projectIds", projectIds);

        let userProjects = await fetchUserProjects();
        console.log("deleteClientProjects userProjects", userProjects);

        let deletedUserProjects =
          userProjects && userProjects.length > 0
            ? userProjects.filter((ele) => projectIds.includes(ele.ProjectID))
            : [];
        console.log(
          "deleteClientProjects deletedUserProjects",
          deletedUserProjects
        );

        if (deletedUserProjects.length > 0) {
          let deleteProjectIds = deletedUserProjects.map(
            (ele) => ele.ProjectID
          );
          console.log(
            "deleteClientProjects deleteProjectIds",
            deleteProjectIds
          );
          let resp = await deleteProjects(deleteProjectIds);
          console.log("deleteClientProjects resp", resp);
          if (resp) {
            return resp;
          }
        }
      }
    } catch (error) {
      console.log("fetchProjectsClients err", error);
    }
  };

  const fetchUserProjects = async () => {
    if (getUserProjects) {
      console.log("fetchUserProjects");
      try {
        let res = await getUserProjects(newUser.UserID, 1);
        console.log("fetchUserProjects res", res);
        if (res) {
          return res;
        }
      } catch (error) {
        console.log("fetchUserProjects err", error);
      }
    }
  };

  const updateUser = async () => {
    console.log("updateUser props", newUser);

    if (updateUserRoles) {
      try {
        let payload = {
          LoginID: newUser.LoginID,
          RoleID: 1,
          UserID: newUser.UserID,
          UserRoleID: newUser.UserRoleID,
          GroupID: newUser.GroupID,
        };
        console.log("updateUser payload", payload);
        const res: any = await updateUserRoles(payload);
        console.log("updateUser res", res);
        if (res) {
          // if (deleteClientIDs.length > 0 && getClientProjects) {
          //   let resp = await deleteClientProjects(deleteClientIDs);
          //   console.log("updateUser resp", resp);
          // }
          setAlertMsg({ type: "Success", msg: "User successfully updated" });
          setShowAlert(true);
          setNewUser({
            LoginID: "",
            RoleID: null,
            GroupID: null,
          });
          setSelectedProjects([]);
          props.refresh();
        }
      } catch (error) {
        console.log("updateUser err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const closeAlert = () => {
    if (alertMsg.type === "Success") {
      props.handleClose();
    }
    setAlertMsg({ type: "", msg: "" });
    setShowAlert(false);
  };

  const createUser = async () => {
    console.log("createUser props", newUser);
    let existingLogins = Object.keys(props.userRoles);
    let isExist = existingLogins.includes(newUser.LoginID);
    console.log("createUser isExist", isExist, existingLogins);
    if (isExist) {
      setAlertMsg({ type: "Warning", msg: "User already exists" });
      setShowAlert(true);
      return;
    }

    if (createUserRoles) {
      try {
        let payload = {
          LoginID: newUser.LoginID,
          GroupID: newUser.GroupID,
          RoleID: 1,
        };
        console.log("createUser payload", payload);
        const res: any = await createUserRoles(payload);
        console.log("createUser res", res);
        if (res) {
          setAlertMsg({ type: "Success", msg: "User successfully created" });
          setShowAlert(true);
          props.refresh();
        }
      } catch (error) {
        console.log("createUser err", error);
        setAlertMsg({ type: "Error", msg: "Unexpected error" });
        setShowAlert(true);
      }
    }
  };

  const handleChange = (e: any) => {
    console.log("handleChange", e.target.value);
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const fetchProjectClients = async (ClientID) => {
    if (getClientProjects) {
      console.log("fetchProjectClients");
      try {
        const _clients = await getClientProjects(ClientID);
        console.log("fetchProject Clients res", _clients);
        setProjectsList(_clients);
      } catch (error) {
        console.log("fetchProjectsClients err", error);
      }
    }
  };

  useEffect(() => {
    console.log(
      "Users ClientID",
      newUser,
      newUser.ClientID && getClientProjects
    );
    if (newUser.ClientID && getClientProjects) {
      // setSelectedProjects([]);
      fetchProjectClients(newUser.ClientID);
    } else {
      fetchProjects();
    }
  }, [newUser.ClientID]);

  useEffect(() => {
    console.log("Existing user", props.selectedUserRoles);
    if (props.selectedUserRoles) {
      setNewUser(props.selectedUserRoles);
      //fetch projects
      if (props.selectedUserRoles.ClientID) {
        // setSelectedProjects([]);
        fetchProjectClients(props.selectedUserRoles.ClientID);
      } else {
        fetchProjects();
      }
      let allProjects = props.selectedUserRoles.allProjects.map(
        (ele) => ele.projectID
      );
      setSelectedProjects(allProjects);
    }
  }, [props.selectedUserRoles]);

  const fetchProjects = async () => {
    if (getAllProjects) {
      console.log("fetchProjects");
      try {
        const _projects = await getAllProjects();
        console.log("fetchProjects res", _projects);
        setProjectsList(_projects);
        // setAllProjectsList(_projects);
      } catch (error) {
        console.log("fetchProjects err", error);
      }
    }
  };

  const fetchRoles = async () => {
    if (getAllRoles) {
      console.log("fetchRoles");
      try {
        const _roles = await getAllRoles();
        console.log("fetchRoles res", _roles);
        setRolesList(_roles);
      } catch (error) {
        console.log("fetchRoles err", error);
      }
    }
  };

  const fetchClientsGroups = async () => {
    if (getClientGroups) {
      console.log("fetchClientsGroups");
      try {
        const _clients = await getClientGroups();
        console.log("fetchClientsGroups res", _clients);
        let sortList = _clients.sort((a, b) =>
          a.GroupName.toLowerCase() > b.GroupName.toLowerCase() ? 1 : -1
        );
        setClientGroupList(sortList);
      } catch (error) {
        console.log("fetchClientsGroups err", error);
      }
    }
  };

  useEffect(() => {
    fetchClientsGroups();
    fetchRoles();
    // fetchProjects();
  }, []);

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle
          sx={{
            padding: "0.5rem 2rem",
            fontSize: "1rem",
            background: "#f1f2f6",
            fontWeight: "600",
          }}
        >
          {props.selectedUserRoles ? "Edit User" : "Add User"}
        </DialogTitle>
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 0,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ padding: "2rem" }}>
          <Grid
            spacing={2}
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
          >
            <Grid item sx={{ width: "100%", display: "flex" }} xs={12} sm={4}>
              <FormControl
                fullWidth
                sx={{ m: 1 }}
              >
                <InputLabel shrink={true}>Client Group</InputLabel>
                <Select
                  label="Client"
                  name="GroupID"
                  value={newUser.GroupID}
                  onChange={handleChange}
                  notched={true}
                  // renderValue={(selected) => selected.join(', ')}
                >
                  {clientsGroupList &&
                    clientsGroupList.map(({ GroupID, GroupName }) => (
                      <MenuItem key={GroupID} value={GroupID}>
                        {/* <Checkbox checked={newUser.ClientID.indexOf(ClientID) > -1} /> */}
                        {GroupName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sx={{ width: "100%", display: "flex" }} xs={12} sm={4}>
              <FormControl required fullWidth sx={{ m: 1 }}>
                <TextField
                  variant="outlined"
                  label="Login Id"
                  name="LoginID"
                  value={newUser.LoginID}
                  onChange={handleChange}
                  disabled={props.selectedUserRoles}
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "2rem" }}>
          <Button onClick={handleClose}>CANCEL</Button>
          {props.selectedUserRoles ? (
            <Button
              variant="contained"
              onClick={updateUser}
              disabled={disableUpdate()}
            >
              Update
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={createUser}
              disabled={disableAdd()}
            >
              Add
            </Button>
          )}
        </DialogActions>

        {loading ? (
          <Grid container justifyContent="center" alignItems="center">
            <Loader />
          </Grid>
        ) : null}
      </Dialog>
      {/* Alert Dialog */}
      <Dialog open={showAlert}>
        <DialogTitle>{alertMsg.type}</DialogTitle>
        <DialogContent>{alertMsg.msg}</DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={closeAlert}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default AddIntelliFiberClients;
